"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Error_1 = tslib_1.__importDefault(require("@mui/icons-material/Error"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const getStyles = () => ({
    root: {
        padding: (theme) => theme.spacing(2, 2, 2, 2),
        height: "100%",
        boxSizing: "border-box",
        overflow: "auto",
    },
});
const DefaultFallbackUI = (props) => {
    const styles = getStyles();
    return (react_1.default.createElement(Box_1.default, { sx: styles.root },
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2, alignContent: "center" },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "center" },
                    react_1.default.createElement(Error_1.default, { color: "error", style: { fontSize: "64px" } }))),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Typography_1.default, { variant: "subtitle1", align: "center", color: "error" }, "Something went wrong")),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Typography_1.default, { variant: "body2", align: "left", color: "textSecondary" }, String(props.error))))));
};
class GridCardErrorBoundary extends react_1.default.Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error, errorInfo) {
        /* tslint:disable-next-line */
        this.props.onRenderError && this.props.onRenderError(error, errorInfo);
        console.log(error, errorInfo);
    }
    render() {
        const { ErrorComponent = DefaultFallbackUI } = this.props;
        if (this.state.error) {
            // You can render any custom fallback UI
            return react_1.default.createElement(ErrorComponent, { error: this.state.error });
        }
        return this.props.children;
    }
}
exports.default = GridCardErrorBoundary;
